<template>
  <MediaBlock
    :cols="columns"
    :cols-centered="item.fields.imageCenteredInRow"
    :content-centered="item.fields.imageCentered"
    :media="mediaObject"
    v-bind="
      ContentfulLivePreview.getProps({
        entryId: item.sys.id,
        fieldId: 'image'
      })
    "
  />
</template>

<script setup lang="ts">
import { MediaBlock } from '@hypercodestudio/basler-components';
import type { IImage } from '~/lib/ContentfulService';
import { generateImageObject } from '~/utils/generateImageObject';
import { mapColsWidth } from '~/utils/mapColsWidth';
import { ContentfulLivePreview } from '@contentful/live-preview';

type Props = {
  item: IImage;
};

const props = defineProps<Props>();
const mediaObject = computed(() => generateImageObject(props.item) || null);

const columns = computed(() =>
  mapColsWidth(props.item.fields.imageWidth ?? '10 cols')
);
</script>
